export enum FileStatus {
  Pending = 'Pending',
  Error = 'Error',
  Uploaded = 'Uploaded',
  Validated = 'Validated',
}
